import React from 'react';

import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { ProfilePictureInvalid } from './ProfilePictureInvalid';
import { EditProfilePictureWrapper } from 'components/shared/ProfilePicture/EditProfilePictureWrapper/EditProfilePictureWrapper';

import './styles.scss';
import { Image } from 'react-bootstrap';

export type ProfilePictureVariant = 'square' | 'circle';
export type ProfilePictureSize = '2x-small' | 'extra-small' | 'small' | 'medium' | 'large';

interface IProfilePictureProps {
    description?: string;
    photo?: string;
    className?: string;
    size?: ProfilePictureSize;
    variant?: ProfilePictureVariant;
    border?: boolean;
    borderVariant?: 'white' | 'light';
    editPhoto?: boolean;
}

export const ProfilePicture = ({
    border,
    className,
    description,
    photo,
    size,
    variant,
    borderVariant,
    editPhoto
}: IProfilePictureProps) => {
    const {t} = useTranslation();
    const [hasError, setHasError] = React.useState<boolean>(false);

    return React.useMemo(() => {

        const classNameComputed = classNames(
            'ProfilePicture',
            {
                [`ProfilePicture--${size}`]: !!size,
                // [`ProfilePicture--${variant}`]: !!variant,
            },
            border,
            {[`border-${borderVariant}`]: (border && borderVariant !== 'light')}
        );

        if (hasError) {
            return (
                <ProfilePictureInvalid className={classNameComputed}/>
            );
        } else if (photo) {
            return (
                <EditProfilePictureWrapper editPhoto={editPhoto}>
                    <div
                        className={classNames(
                            'ProfilePicture',
                            className,
                            {
                                [`ProfilePicture--${size}`]: !!size,
                            }, 'position-relative')}
                    >
                        <div className="ProfilePicture__maskContainer">
                            <Image
                                src={photo}
                                alt={description}
                                className={classNameComputed}
                                onError={() => setHasError(true)}
                            />
                        </div>
                        <div className="ProfilePicture__mask"/>
                    </div>
                </EditProfilePictureWrapper>
            );
        } else {
            return (
                <img
                    src={'/assets/images/empty-profile-image.svg'}
                    alt={t('common.noProfileImage', 'Please add profile picture')}
                    className={classNameComputed}
                    onError={() => setHasError(true)}
                />
            );
        }
    }, [photo, description, className, size, variant, border, hasError, setHasError, borderVariant, t, editPhoto]);
};

ProfilePicture.defaultProps = {
    variant: 'circle',
    borderVariant: 'white',
};